import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from 'react';
import { Box, Chip, Typography, Collapse } from '@applyboard/ui-components';
import { convertUTCDateToShortForm } from '@applyboard/ui-utils';
import { ChevronDownOutlineIcon, InfoOutlineIcon } from '@applyboard/ui-icons';
import { IconButton as CardIconButton } from "../Card";
import { ConditionsModalTitle, IntakeConditionsModal } from "./IntakeConditionsModal";
import { EntryContainer, IntakeInfoModalButton } from "./style";
import { INTAKE_CHIP_PROPS, NO_DATA_AVAILABLE } from "./IntakeChipHelper";
import IntakeTooltip from "./IntakeTooltip";
export var IntakeEntry = function IntakeEntry(_ref) {
  var intake = _ref.intake,
    showCloseConditonToUser = _ref.showCloseConditonToUser,
    onToggleCollapsed = _ref.onToggleCollapsed;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    conditionModalTitle = _useState4[0],
    setConditionModalTitle = _useState4[1];
  var closeConditionModal = useCallback(function () {
    setConditionModalTitle(null);
  }, [setConditionModalTitle]);
  var formattedStateDate = convertUTCDateToShortForm(new Date(intake.startDate));
  var handleExpandCard = useCallback(function () {
    setIsExpanded(function (previousValue) {
      return !previousValue;
    });
    onToggleCollapsed(formattedStateDate);
  }, [onToggleCollapsed, setIsExpanded, formattedStateDate]);
  var intakeChip = INTAKE_CHIP_PROPS[intake.generalStatus];
  var shouldRenderDeadlineInfoIcon = showCloseConditonToUser && intake.generalDeadlineExceptions.length > 0;

  // this is to generate a date/time string in the format of
  // YYYY-MM-DD HH:MM A/PM TZ (i.e. 2022-07-10 11:59 AM EDT)
  var formatDate = function formatDate(_ref2) {
    var date = _ref2.date,
      time = _ref2.time,
      timeZoneCode = _ref2.timeZoneCode;
    var formatTime = function formatTime(time) {
      var _time$split = time.split(':'),
        _time$split2 = _slicedToArray(_time$split, 2),
        hours = _time$split2[0],
        minutes = _time$split2[1];
      var period = parseInt(hours) >= 12 ? 'PM' : 'AM';
      var formattedHours = parseInt(hours) % 12 || 12;
      return "".concat(formattedHours, ":").concat(minutes, " ").concat(period);
    };
    var formattedTime = formatTime(time);
    return "".concat(date, " ").concat(formattedTime, " ").concat(timeZoneCode);
  };
  var formattedOpenDateTime = formatDate(intake.openTime);
  var formattedDeadlineDateTime = formatDate(intake.deadlineTime);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EntryContainer, {
    py: 2
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Chip, {
    border: false,
    color: intakeChip.color,
    size: "small"
  }, intakeChip.caption), /*#__PURE__*/React.createElement(IntakeTooltip, {
    generalStatus: intake.generalStatus,
    generalWaitlistExceptions: intake.generalWaitlistExceptions
  }), /*#__PURE__*/React.createElement(CardIconButton, {
    onClick: handleExpandCard,
    "aria-expanded": isExpanded,
    "aria-label": "show more",
    size: "small",
    isExpanded: isExpanded
  }, /*#__PURE__*/React.createElement(ChevronDownOutlineIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    ml: 1
  }, formattedStateDate)), /*#__PURE__*/React.createElement(Collapse, {
    "in": isExpanded,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "Open date"), /*#__PURE__*/React.createElement(IntakeInfoModalButton, {
    "aria-label": "show open conditions",
    onClick: function onClick() {
      return setConditionModalTitle(ConditionsModalTitle.OpenDate);
    }
  }, /*#__PURE__*/React.createElement(InfoOutlineIcon, null))), /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, intake.openDate ? formattedOpenDateTime : /*#__PURE__*/React.createElement(React.Fragment, null, NO_DATA_AVAILABLE)))), /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "Submission deadline"), shouldRenderDeadlineInfoIcon ? /*#__PURE__*/React.createElement(IntakeInfoModalButton, {
    "aria-label": "show close conditions",
    onClick: function onClick() {
      return setConditionModalTitle(ConditionsModalTitle.Deadline);
    }
  }, /*#__PURE__*/React.createElement(InfoOutlineIcon, null)) : null), /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, intake.submissionDeadline ? formattedDeadlineDateTime : /*#__PURE__*/React.createElement(React.Fragment, null, NO_DATA_AVAILABLE))))))), conditionModalTitle && /*#__PURE__*/React.createElement(IntakeConditionsModal, {
    generalClosedConditions: intake.generalDeadlineExceptions,
    generalOpenedConditions: intake.generalOpendateExceptions,
    generalStatus: intake.generalStatus,
    modalTitle: conditionModalTitle,
    openDate: formattedOpenDateTime,
    onClose: closeConditionModal
  }));
};